import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_6 = { class: "col p-0" }
const _hoisted_7 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_10 = { class: "col p-0" }
const _hoisted_11 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_12 = { class: "col p-0" }
const _hoisted_13 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_14 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_15 = { class: "col p-0" }
const _hoisted_16 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_17 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_18 = { class: "col p-0" }
const _hoisted_19 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_20 = { class: "col p-0" }
const _hoisted_21 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_22 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_23 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_24 = { class: "col p-0" }
const _hoisted_25 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_26 = { class: "col p-0" }
const _hoisted_27 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_28 = { class: "col p-0" }
const _hoisted_29 = ["disabled", "placeholder"]
const _hoisted_30 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_31 = { class: "col p-0" }
const _hoisted_32 = ["disabled", "placeholder"]
const _hoisted_33 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_34 = { class: "col p-0" }
const _hoisted_35 = { class: "form-group mb-2 col" }
const _hoisted_36 = { class: "col-auto p-0 text-end" }
const _hoisted_37 = {
  key: 0,
  class: "row m-4 mb-0 mt-0"
}
const _hoisted_38 = { class: "col-sm-12" }
const _hoisted_39 = { class: "card card-body mb-0 text-center text-muted py-3" }
const _hoisted_40 = {
  key: 1,
  class: "row m-4 mb-0 mt-0"
}
const _hoisted_41 = { class: "col-sm-12" }
const _hoisted_42 = { class: "card card-body mb-0" }
const _hoisted_43 = { class: "overflow-auto" }
const _hoisted_44 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_45 = { class: "bg-light" }
const _hoisted_46 = { class: "text-capitalize-first" }
const _hoisted_47 = { class: "text-capitalize-first text-end" }
const _hoisted_48 = { class: "text-capitalize-first text-end" }
const _hoisted_49 = { class: "text-capitalize-first text-end" }
const _hoisted_50 = { class: "text-capitalize-first text-end" }
const _hoisted_51 = { class: "text-capitalize-first text-end" }
const _hoisted_52 = { class: "text-end" }
const _hoisted_53 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchantMultiselect = _resolveComponent("MerchantMultiselect")!
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_MerchantMultiselect, {
                    multiple: true,
                    modelValue: _ctx.merchantsFilter,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.merchantsFilter) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_StoreMultiselect, {
                    multiple: true,
                    modelValue: _ctx.storesFilter,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storesFilter) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_TrafficGroupMultiselect, {
                    multiple: true,
                    small: "",
                    modelValue: _ctx.trafficGroupsFilter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trafficGroupsFilter) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.requestDTO.fromDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                    mode: "dateTime",
                    "model-modifiers": {string: true},
                    is24hr: "",
                    masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.from_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_13)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.requestDTO.toDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                    mode: "dateTime",
                    "model-modifiers": {string: true},
                    is24hr: "",
                    masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.to_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_16)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_TraderMultiselect, {
                    multiple: true,
                    modelValue: _ctx.tradersFilter,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tradersFilter) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Multiselect, {
                    id: "methods",
                    class: "multiselect-sm",
                    modelValue: _ctx.requestDTO.methods,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
                    options: _ctx.store.getters['currencyMethods/methods'](),
                    "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.payment_methods')
                  }, {
                    option: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_PayMethodIcon, {
                          "icon-class": "icon",
                          method: props.option
                        }, null, 8, ["method"]),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Multiselect, {
                    id: "options",
                    class: "multiselect-sm",
                    modelValue: _ctx.requestDTO.options,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                    options: _ctx.store.getters['currencyMethods/options'](),
                    "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.payment_options')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_Multiselect, {
                    id: "currency",
                    class: "multiselect-sm multiselect-capitalize",
                    modelValue: _ctx.requestDTO.currency,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.currency) = $event)),
                    options: _ctx.store.getters['currencyMethods/currencies'],
                    "custom-label": (opt) => opt,
                    multiple: false,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.currency')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    disabled: !_ctx.requestDTO.currency,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestDTO.amountFrom) = $event)),
                    class: "form-control form-control-sm",
                    placeholder: _ctx.helper.trans('labels.from_sum')
                  }, null, 8, _hoisted_29), [
                    [_vModelText, _ctx.requestDTO.amountFrom]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    disabled: !_ctx.requestDTO.currency,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestDTO.amountTo) = $event)),
                    class: "form-control form-control-sm",
                    placeholder: _ctx.helper.trans('labels.to_sum')
                  }, null, 8, _hoisted_32), [
                    [_vModelText, _ctx.requestDTO.amountTo]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_Multiselect, {
                    id: "types",
                    class: "multiselect-sm",
                    modelValue: _ctx.requestDTO.types,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestDTO.types) = $event)),
                    options: Object.values(_ctx.Direction),
                    "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.type')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)), ["prevent"])),
                    class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      (!_ctx.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.helper.trans('statistic.issuanceTime.no_data')), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("table", _hoisted_44, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_45, [
                        _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.helper.trans('statistic.issuanceTime.hour')), 1),
                        _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.helper.trans('statistic.issuanceTime.count')), 1),
                        _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.helper.trans('statistic.issuanceTime.p50')), 1),
                        _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.helper.trans('statistic.issuanceTime.p90')), 1),
                        _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.helper.trans('statistic.issuanceTime.p98')), 1),
                        _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.helper.trans('statistic.issuanceTime.p99')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.hour
                        }, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatHour(item.hour)), 1),
                          _createElementVNode("td", _hoisted_52, [
                            _createTextVNode(_toDisplayString(item.count) + " ", 1),
                            (item.count < 10)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: "fa fa-warning text-warning ms-1",
                                  title: _ctx.helper.trans('statistic.issuanceTime.low_sample_warning')
                                }, null, 8, _hoisted_53)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", {
                            class: _normalizeClass(["text-end", {'text-danger': _ctx.isOverThreshold(item.p50)}])
                          }, _toDisplayString(_ctx.formatPercentile(item.p50)), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(["text-end", {'text-danger': _ctx.isOverThreshold(item.p90)}])
                          }, _toDisplayString(_ctx.formatPercentile(item.p90)), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(["text-end", {'text-danger': _ctx.isOverThreshold(item.p98)}])
                          }, _toDisplayString(_ctx.formatPercentile(item.p98)), 3),
                          _createElementVNode("td", {
                            class: _normalizeClass(["text-end", {'text-danger': _ctx.isOverThreshold(item.p99)}])
                          }, _toDisplayString(_ctx.formatPercentile(item.p99)), 3)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }, 512))
}